import React, { createContext, useContext } from 'react';

const PrimeBenefitsLinkContext = createContext(null);
const EmptyLink = () => <></>;

export const PrimeBenefitsLinkProvider = ({
  primeBenefitsLink = <></>,
  children,
}) => (
  <PrimeBenefitsLinkContext.Provider value={primeBenefitsLink}>
    {children}
  </PrimeBenefitsLinkContext.Provider>
);

export const usePrimeBenefitsLink = () =>
  useContext(PrimeBenefitsLinkContext) || <EmptyLink />;
